// extracted by mini-css-extract-plugin
module.exports = {"label":"MaskedInput__label___2Txq_","tooltip":"MaskedInput__tooltip___1hpXw"};